export default __webpack_public_path__ + "static/media/tanja.2e041187.jpg";